<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
export default {
    components: {},
    data: function () {
        return {
            voucherText: "",
            isLoading: false
        }
    },
    computed: {
        currentUser: function(){
            return this.$store.getters['auth/currentUser'];
        },
        currentTab: function(){
            return this.$store.getters['sale/currentTab'];
        },
        voucherDiscount: function(){
            return typeof this.currentTab != 'undefined' && typeof this.currentTab.info != 'undefined' && typeof this.currentTab.info.voucherDiscount != 'undefined' ? this.currentTab.info.voucherDiscount : 0;
        },
        customerDiscountValue: function(){
            return typeof this.currentTab != 'undefined' && typeof this.currentTab.info != 'undefined' && typeof this.currentTab.info.customerDiscountValue != 'undefined' ? this.currentTab.info.customerDiscountValue : 0;
        },
    },
    methods: {
        ...urlMethods,
        removeDiscountCustomer(){
            this.$store.dispatch("sale/removeDiscountCustomer");
            this.$bvModal.hide('modal-select-discount');
        },
        removeDiscountVoucher(){
            this.$store.dispatch("sale/removeDiscountVoucher");
            this.$bvModal.hide('modal-select-discount');
        },
    },
    mounted() {
    },
};
</script>

<template>
<div>
<b-modal id="modal-select-discount" title="Lựa chọn hình thức giảm giá" title-class="font-18" hide-footer>
    <p>Voucher không áp dụng cho VIP, vui lòng chọn hình thức giảm giá</p>
    <div class="btn-group-vertical" role="group" style="width: 100%">
        <div style="width: 100%; margin-bottom: 5px;">
            <input type="radio" name="select_discount" class="btn-check" @click="removeDiscountCustomer" id="btn-remove-discount-customer" value="customer" />
            <label style="width: 100%; margin-bottom: 10px;" class="btn btn-outline-info mb-0" for="btn-remove-discount-customer">Giảm theo voucher - {{ voucherDiscount | VND }}</label>
        </div>
        <div style="width: 100%; margin-bottom: 5px;">
            <input type="radio" name="select_discount" class="btn-check" @click="removeDiscountVoucher" id="btn-remove-discount-voucher" value="voucher" />
            <label style="width: 100%; margin-bottom: 10px;" class="btn btn-outline-info mb-0" for="btn-remove-discount-voucher">Giảm theo VIP - {{ customerDiscountValue | VND }}</label>
        </div>
    </div>
</b-modal>
</div>
</template>
